import { useState, useEffect, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, IconButton, Typography } from '@mui/material';
import _ from 'lodash';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useUpdateCompany } from '../../hooks/useCompany';
import { useUserStore } from '../../stores/userStore';
import AddressCard from './components/AddressCard';

const RewardShipping = () => {
  const navigate = useNavigate();
  const companyInfo = useUserStore((state) => state.companyInfo);
  const setCompanyInfo = useUserStore((state) => state.setCompanyInfo);
  const [addressLists, setAddressLists] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState('');

  const { mutateAsync: updateCompany } = useUpdateCompany();

  const handleDeleteAddress = useCallback(
    async (addressId) => {
      try {
        const newAddressList = companyInfo.address.filter((item) => item._id !== addressId);

        const response = await updateCompany({
          params: { id: companyInfo._id },
          dto: { address: newAddressList },
        });

        if (response.Code === '20100') {
          const sortedAddressList = _.orderBy(response?.Data?.address, 'default', 'desc');
          setCompanyInfo({
            ...response.Data,
            address: sortedAddressList,
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    [companyInfo, setCompanyInfo, updateCompany]
  );

  useEffect(() => {
    if (companyInfo && companyInfo.address) {
      const myAddressLists = _.orderBy(companyInfo.address, 'default', 'desc').map((item) => {
        if (item.default && !selectedAddress) {
          setSelectedAddress(item._id);
        }

        return (
          <AddressCard
            key={item._id}
            addressId={item._id}
            code={companyInfo.code}
            isDefault={item.default}
            name={item.name}
            detail={item.detail}
            alley={item.alley}
            street={item.street_name}
            subdistrict={item.subdistrict}
            district={item.district}
            province={item.province}
            zipcode={item.zip_code}
            phonenumber={item.phonenumber}
            selected={selectedAddress}
            onDelete={handleDeleteAddress}
            setSelected={setSelectedAddress}
          />
        );
      });

      setAddressLists(myAddressLists);
    }
  }, [companyInfo, selectedAddress, setSelectedAddress, handleDeleteAddress]);

  return (
    <>
      <Helmet>
        <title>Address | Caltex StarCard</title>
      </Helmet>

      <Box sx={{ padding: '10px 16px 60px' }}>
        {/* Back button */}
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            width: '100px',
            height: '40px',
            fontSize: '1.25rem',
            color: 'white',
            margin: '10px 0 20px',
            backgroundColor: '#8E8E8E',
            padding: '2px 10px',
            borderRadius: '8px',

            '&:hover': {
              color: 'white',
              backgroundColor: '#8E8E8E',
              opacity: '.85',
            },
          }}
        >
          <ArrowBackIosIcon
            sx={{
              fontSize: '1rem',
              fontWeight: '400',
              color: 'white',
            }}
          />
          ย้อนกลับ
        </IconButton>

        {/* Title */}
        <Box
          sx={{
            backgroundColor: '#E1000C',
            color: 'white',
            padding: '8px 10px',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '20px',
          }}
        >
          <Typography component={'h1'} sx={{ fontSize: '1.85rem', fontWeight: '500' }}>
            ที่อยู่ของฉัน
          </Typography>
        </Box>

        {/* Address list */}
        {addressLists}

        {/* Add button */}
        <IconButton
          aria-label="เพิ่มที่อยู่"
          onClick={() => navigate('/address/add')}
          sx={{
            width: '100%',
            height: '45px',
            margin: '20px 0',
            backgroundColor: '#E1000C',
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            '&:hover': {
              opacity: '.85',
              backgroundColor: '#E1000C',
            },
          }}
        >
          <AddIcon sx={{ fontSize: '1.75rem', lineHeight: '1.5rem', color: 'white' }} />
          <Box
            component={'span'}
            sx={{ fontSize: '1.5rem', lineHeight: '1.5rem', fontWeight: '500', color: 'white' }}
          >
            เพิ่มที่อยู่ใหม่
          </Box>
        </IconButton>
      </Box>
    </>
  );
};

export default RewardShipping;
